// extracted by mini-css-extract-plugin
export default {"container":"QuoteTileSmall-module__container__X8dhu","topRow":"QuoteTileSmall-module__topRow__ImVeN","imgContainer":"QuoteTileSmall-module__imgContainer__X0gHK"};